export default __webpack_public_path__ + "static/media/orange-drank.c6c8ae86.jpg";